import Layout from '@/View/CRM/layout/layout.vue'
export const CRM = {
  // CRM dashboard Start
  path: '/crm',
  component: Layout,
  hidden: false,
  redirect: '/crm/dashboard',
  name: 'CRM',
  meta: {
    breadCrumb: 'CRM',
    title: 'dashboards',
    icon: 'dashboard',
    selected: false,
    permission: ''
  },
  children: [
    {
      path: '/crm/dashboard',
      component: () => import('@/View/CRM/dashboard/dashboard.vue'),
      name: 'CRMDashboard',
      meta: {
        breadCrumb: 'Dashboard',
        icon: 'dashboard',
        title: 'Dashboard',
        selected: false,
        permissionList: []
      }
    },
    { // Customer Object Start
      path: '/crm/customer',
      component: () => import('@/View/CRM/Main/main.vue'),
      hidden: false,
      redirect: '/crm/customer/customerlist',
      name: 'customerList',
      meta: {
        breadCrumb: 'Customer',
        title: 'Customers',
        selected: false,
        permissionList: []
      },
      children: [{
        path: '/crm/customer/customerlist',
        component: () => import('@/View/CRM/Customer/customerlist.vue'),
        name: 'customerList',
        meta: {
          breadCrumb: 'Customers',
          icon: '',
          title: 'CustomersList',
          selected: false,
          permissionList: []
        }
      },
      {
        path: '/crm/customer/addNewCustomer',
        component: () => import('@/View/CRM/Customer/addnewCustomer.vue'),
        name: 'NewCustomer',
        meta: {
          breadCrumb: 'NewCustomer',
          icon: '',
          title: 'New Customer',
          selected: false,
          permissionList: []
        }
      },
      {
        path: '/crm/customer/details/:companyMasterId',
        component: () => import('@/View/CRM/Customer/CustomerDetails/customerDetails.vue'),
        name: 'Customerdetails',
        meta: {
          breadCrumb: 'details',
          icon: '',
          title: 'Customer Details',
          selected: false,
          permissionList: []
        }
      }]
    },
    { // Customer Setting Object Start
      path: '/crm/setting',
      component: () => import('@/View/CRM/Main/main.vue'),
      hidden: false,
      redirect: '/crm/setting/dashboard',
      name: 'CRMSetting',
      meta: {
        breadCrumb: 'Setting',
        title: 'Settings',
        selected: false,
        permissionList: []
      },
      children: [
        {
          path: '/crm/setting/dashboard',
          hidden: true,
          name: 'CRMSettingDashboard',
          component: () => import('@/View/CRM/Settings/SettingDashboard/dashboard.vue'),
          meta: {
            title: 'Dashboard',
            breadCrumb: 'Dashboard'
          }
        },
        {
          path: '/crm/setting/leadsource',
          name: 'CLeadSource',
          hidden: false,
          component: () => import('@/View/CRM/Settings/LeadSource/SourceList.vue'),
          meta: {
            title: 'Lead Source',
            breadCrumb: 'leadsource',
            icon: 'fas fa-question',
            permissionList: ['crm_setting__lead_source__manage']
          }
        },
        {
          path: '/crm/setting/leadstatus',
          name: 'CLeadStatus',
          hidden: false,
          component: () => import('@/View/CRM/Settings/LeadStatus/leadstatusList.vue'),
          meta: {
            title: 'Lead Status',
            breadCrumb: 'leadstatus',
            icon: 'fas fa-question-circle',
            permissionList: ['crm_setting__lead_status__manage']
          }
        },
        {
          path: '/crm/setting/contactTitle',
          name: 'ContactTitle',
          hidden: false,
          component: () => import('@/View/CRM/Settings/ContactTitle/contactTitleList.vue'),
          meta: {
            title: 'Contact Title',
            breadCrumb: 'contacttitle',
            icon: 'fas fa-male',
            permissionList: ['crm_setting__contact_title__manage']
          }
        },
        {
          path: '/crm/setting/contactPosition',
          name: 'ContactPosition',
          hidden: false,
          component: () => import('@/View/CRM/Settings/ContactPosition/ContactPositionList.vue'),
          meta: {
            title: 'Contact Position',
            breadCrumb: 'contactPosition',
            icon: 'fas fa-user-tie',
            permissionList: ['crm_setting__contact_position__manage']
          }
        }
      ]
    },
    { // Lead Object Start
      path: '/crm/lead',
      component: () => import('@/View/CRM/Main/main.vue'),
      hidden: false,
      redirect: '/crm/lead/leadlist',
      name: 'leadList',
      meta: {
        breadCrumb: 'Lead',
        title: 'Leads',
        selected: false,
        permissionList: []
      },
      children: [{
        path: '/crm/lead/leadlist',
        component: () => import('@/View/CRM/Leads/leadList.vue'),
        name: 'leadList',
        meta: {
          breadCrumb: 'Leads',
          icon: '',
          title: 'LeadList',
          selected: false,
          permissionList: []
        }
      },
      {
        path: '/crm/lead/addNewLead',
        component: () => import('@/View/CRM/Customer/addnewCustomer.vue'),
        name: 'addNewLead',
        meta: {
          breadCrumb: 'addNewLead',
          icon: '',
          title: 'New Lead',
          selected: false,
          permissionList: []
        }
      },
      {
        path: '/crm/lead/detail/:companyMasterId',
        component: () => import('@/View/CRM/Leads/leadDetails.vue'),
        name: 'leadDetails',
        meta: {
          breadCrumb: 'details',
          icon: '',
          title: 'Lead Details',
          selected: false,
          permissionList: []
        }
      }]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/View/CRM/router/index.js